<app-seccion
[titulo]="'Como llegar a la Secretaría de Planeamiento Estratégico'"
[fondo]="'azul'"
></app-seccion>
<div class="embed-responsive embed-responsive-4by3 m-0 p-0 ">
  <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3638.7995554740164!2d-65.26953832499602!3d-24.213798785884986!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x941b07f37ba75483%3A0x16ff1039521b7645!2sMinisterio%20de%20Educaci%C3%B3n%20-%20Complejo%20Ministerial!5e0!3m2!1ses-419!2sar!4v1710135553044!5m2!1ses-419!2sar" width="600" height="150" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
</div>
